/* @flow */

export const MARKET_AUTOCOMPLETE_TOPICS = 'MARKET_AUTOCOMPLETE_TOPICS';
export const MARKET_AUTOCOMPLETE_USERS = 'MARKET_AUTOCOMPLETE_USERS';
